export default __webpack_public_path__ + "static/media/m_l.2c749b63.wav";